<template>
  <div class="x-tablelist-view" data-automation="group">
    <!-- 表格 -->
    <div class="x-table-box x-padding-y">
      <ux-table
        ref="table"
        maxHeight="100%"
        :hide-on-single-page="true"
        :data="tableData.list"
        :columns="columns"
        :emptyText="$t('HT.nodata')"
        layout="total, sizes, prev, pager, next"
      ></ux-table>
    </div>
  </div>
</template>
<script>
import changeCurrency from './template/changeCurrency';
export default {
  components: {
    changeCurrency
  },
  data() {
    return {
      columns: [
        // 表头数据
        {
          label: '消息类型',
          prop: 'type',
          tooltip: true,
          formatter: (row, column, cellValue) => {
            return this.$opt.switchStr(cellValue, this.$opt.messageType);
          }
        },
        {
          label: '分钟限制',
          prop: 'minute',
          tooltip: true
        },
        {
          label: '每日限制',
          prop: 'day',
          tooltip: true
        },
        {
          label: 'VIP分钟限制',
          prop: 'vip_minute',
          tooltip: true
        },
        {
          label: 'VIP每日限制',
          prop: 'vip_day',
          tooltip: true
        },
        {
          label: '操作',
          hidden: !this.$hasModule(42),
          render: (h, params) => {
            return h('my-table-btn', {
              props: {
                data: ['修改'],
                colors: ['#0087ff'],
                event: ['toChange']
              },
              on: {
                toChange: () => {
                  this.$uxModal.show({
                    title: '修改通用发送限制',
                    content: (h) => {
                      return h(changeCurrency, {
                        props: { data: params }
                      });
                    },
                    confirm: (data) => {
                      this.modify(data);
                    }
                  });
                }
              }
            });
          }
        }
      ],
      tableData: {
        // 表格数据
        totalSize: 0,
        list: []
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    /**
     * 获取列表
     * @param {Object} params 请求参数
     */
    getList() {
      this.$uxLoading.show();
      this.$api.message.getLimit().then((res) => {
        if (res.code == 10000) {
          this.tableData = {
            totalSize: res.total_size,
            list: res.data
          };
        }
      });
    },

    /**
     * 修改列表
     * @param {Object} params 表单提交参数
     */
    modify(data) {
      this.$uxLoading.show();
      this.$api.message.changeLimit(data.id, data).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success('修改成功');
          this.getList();
        }
      });
    }
  }
};
</script>
